import React from 'react';
const ListboxContext = /*#__PURE__*/React.createContext({});
const useListboxContext = () => React.useContext(ListboxContext);
export { ListboxContext, useListboxContext };